import { Component, OnInit, inject } from '@angular/core';
import { ErzeugungsanlageService } from '../../service/erzeugungsanlage/erzeugungsanlage.service';
import { ActivatedRoute } from '@angular/router';
import { TnbUser } from '../../service/auth/tnb-user';
import { InstallierteLeistungAggregate } from '../../domain/model/report/installierte-leistung-aggregate';
import { ErzeugungsanlageFilter } from '../../service/erzeugungsanlage/erzeugungsanlage-filter';
import { combineLatest, Observable } from 'rxjs';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { PreferencesService } from '../../service/common/preferences/preferences.service';
import { Leistungseinheit } from '../../domain/model/leistungseinheit';
import { NetzzuordnungSnapshot } from '../../domain/model/netzzuordnung-snapshot';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { DashboardService } from '../../service/dashboard/dashboard.service';
import { DashboardInfoContainer } from '../../domain/model/dashboard-info-container';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'tnb-dashboard-page',
    templateUrl: './dashboard-page.component.html',
    styleUrls: [
        './dashboard-page.component.scss',
    ],
    standalone: false,
})
export class DashboardPageComponent implements OnInit {
    private readonly erzeugungsanlageService = inject(ErzeugungsanlageService);
    private readonly route = inject(ActivatedRoute);
    private readonly preferencesService = inject(PreferencesService);
    readonly authService = inject(AuthenticationService);
    readonly netzbetreiberService = inject(NetzbetreiberService);
    private readonly teilgebietSelectionService = inject(TeilgebietSelectionService);
    private readonly dashboardService = inject(DashboardService);

    public nvnbTasksSnapshot$: Observable<{
        netzzuordnungSnapshot: NetzzuordnungSnapshot
    }> | null;

    public dashboardInfoDto$: Observable<DashboardInfoContainer | null>;

    public readonly Leistungseinheit = Leistungseinheit;

    public installierteLeistungByAnlagentyp$: Observable<InstallierteLeistungAggregate[]>;
    public installierteLeistungByEnergieart$: Observable<InstallierteLeistungAggregate[]>;
    public tnbUser: TnbUser;
    public leistungseinheitViewMode: Leistungseinheit = Leistungseinheit.KW;

    constructor() {
        this.tnbUser = this.route.snapshot.data.profile;
    }

    toggleViewMode(event: MatButtonToggleChange) {
        this.preferencesService.setPreferredLeistungseinheitView(event.source.value);
    }

    ngOnInit() {
        let isWestnetzUserOrAdmin = this.authService.isWestnetzUserOrWestnetzAdmin(this.tnbUser);
        let isStadtwerk = this.authService.isNvnb(this.tnbUser);
        let selectedStadtwerkeId = this.teilgebietSelectionService.getSelectedStadtwerkeId();

        this.dashboardInfoDto$ = this.dashboardService.getDashboardInfo(isWestnetzUserOrAdmin);

        if (isStadtwerk) {
            this.initNvnbTasksSnapshop(selectedStadtwerkeId);
        }

        const filter = new ErzeugungsanlageFilter();
        if (this.tnbUser.netzbetreiberType !== 'WESTNETZ') {
            filter.stadtwerkeId = selectedStadtwerkeId;
            this.leistungseinheitViewMode = this.preferencesService.getPreferredLeistungseinheitView(Leistungseinheit.KW);
        } else {
            this.leistungseinheitViewMode = this.preferencesService.getPreferredLeistungseinheitView(Leistungseinheit.MW);
        }

        this.installierteLeistungByAnlagentyp$ = this.erzeugungsanlageService.aggregateInstallierteLeistung(
            'anlagentyp', filter);
        this.installierteLeistungByEnergieart$ = this.erzeugungsanlageService.aggregateInstallierteLeistung(
            'energieart', filter);

    }

    shouldDisplayTodoListHeadline(dashboardInfoContainer: DashboardInfoContainer): boolean {
        return dashboardInfoContainer.numberOfUncofirmedNetzzuordnungUUIDs > 0 ||
            dashboardInfoContainer.numberOfDeleteNetzzuordnung > 0 ||
            dashboardInfoContainer.isErzeugungsanlageLastChangedAndNetzbeteiberLastUpdateToOld ||
            this.shouldDisplayDatenabfrageATSTask(dashboardInfoContainer);
    }

    shouldDisplayDatenabfrageATSTask(dashboardInfoDto: DashboardInfoContainer): boolean {
        return dashboardInfoDto.aufteilungsSchluesselSubmitted === false &&
            dashboardInfoDto.isUserAssignedToAktiveDatenabfrage &&
            dashboardInfoDto.aktiveDatenAbfrage !== null &&
            this.authService.isNvnb(this.tnbUser);
    }

    private initNvnbTasksSnapshop(selectedStadtwerkeId: string) {

        this.nvnbTasksSnapshot$ = combineLatest([
            this.dashboardService.getNetzzuordnungSnapshot$(selectedStadtwerkeId),
        ]).pipe(
            map(([
                netzzuordnungSnapshot,
            ]) => {
                return {
                    netzzuordnungSnapshot: netzzuordnungSnapshot,
                };
            }),
        );
    }
}
